import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AdminComponent } from '../admin/admin.component';
import { ParticularComponent } from './particular/particular.component';
import { CustomerComponent } from './customer/customer.component';
import { GeneralPaymentComponent } from './general-payment/general-payment.component';
import { GeneralPaymentCancelComponent } from './general-payment-cancel/general-payment-cancel.component';
import { GeneralPaymentReceiptPrintComponent } from './general-payment-receipt-print/general-payment-receipt-print.component';

const routes: Routes = [
  {
    path: '',
    component: AdminComponent,
    children: [
      { path: 'particular', component: ParticularComponent, pathMatch: 'full' },
      { path: 'customer', component: CustomerComponent, pathMatch: 'full' },
      { path: 'generalpayment', component: GeneralPaymentComponent, pathMatch: 'full' },
      { path: 'generalpaymentcancel', component: GeneralPaymentCancelComponent, pathMatch: 'full' }, 


    ]
  },
  {
    path: '', children: [      
      { path: 'generalpaymentreceiptprint', component: GeneralPaymentReceiptPrintComponent, pathMatch: 'full' },
          
    ]
  }


];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class GeneralpaymentRoutingModule { }
